// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__1ldNV"};